import { IPrice } from './../../interfaces/cart-details.interface';
import { Component, Input, OnInit } from '@angular/core';
import { IOrderSummary } from '../../interfaces/order-summary.interface';
import { YourOfferService } from '../../cart-process/your-offer.service';
import { CommonInfoService } from '../../cart-process/common-info.service';
import SlotService from '../../cart-process/slot.service';
import {
  NotificationProviderService,
  NotificationProviderTypeEnum
} from '../../external-interfaces/notification-provider.service';

@Component({
  selector: 'order-summary',
  templateUrl: './order-summary.component.html',
})
export class OrderSummaryComponent implements OnInit {
  @Input() deliveryCost: IPrice;
  @Input() public linkNext: string;
  @Input() set orderSummary(orderData: IOrderSummary.Root) {
    this.orderData = orderData;
    this.updateProcess();
  }

  public orderData: IOrderSummary.Root;
  public showWhatHappenNowSection: boolean;
  public showSummarySection: boolean;
  public isRetentionWithoutDevice: boolean;
  public offerTitle: string;
  public isVirginBrand: boolean;
  public header: string;

  constructor(
    public yourOffer: YourOfferService,
    protected commonInfo: CommonInfoService,
    private slotService: SlotService,
    private notificationProvider: NotificationProviderService
  ) {
  }

  ngOnInit() {
    this.notificationProvider.subscribe(NotificationProviderTypeEnum.COMMON_INFO, (commonInfo: CommonInfoService) => {
      if (commonInfo) {
        this.updateProcess();
      }
    });

    this.notificationProvider.subscribe(NotificationProviderTypeEnum.COMMON_INFO, (commonInfo: CommonInfoService) => {
      if (commonInfo) {
        this.offerTitle = commonInfo.offerTitle;
        this.isVirginBrand = commonInfo.isVirginBrand;
      }
    });

    this.header = this.isVirginBrand ? 'summaryPage.virginHeader' : 'summaryPage.header';
  }

  private updateProcess() {
    this.isRetentionWithoutDevice = this.commonInfo.isRetentionOffer && !this.slotService.hasAtLeastOneDeviceInCart();
    this.showSummarySection = !this.isRetentionWithoutDevice;
    this.showWhatHappenNowSection = !!this.orderData?.whatHappensNow?.length;
  }
}
